import './styles/main.scss';

import App from './components/app';

export default App;
